export default __webpack_public_path__ + "static/media/Girdle of the Proven Champion.4edede19.jpg";